import { db, docsFromSnapshot } from '@/firebase';

export const eventTypes = {
  RESOURCE_WORK_HOURS: 'RESOURCE_WORK_HOURS',
  RESOURCE_BREAK: 'RESOURCE_BREAK',
  RESOURCE_HOLIDAY: 'RESOURCE_HOLIDAY',
  RESOURCE_SICK: 'RESOURCE_SICK'
};

export const DEFAULT_ROSTER_EVENT = {
  storeId: null,
  resourceId: null,
  type: eventTypes.RESOURCE_WORK_HOURS,
  start: null,
  end: null,
  created: null,
  lastModified: null
};

export const DEFAULT_BREAK_EVENT = {
  ...DEFAULT_ROSTER_EVENT,
  type: eventTypes.RESOURCE_BREAK
};

const state = {
  roster: {},
  subscription: null
};

const getters = {
  roster: state => state.roster,
  rosterBreaks: state =>
    Object.values(state.roster).filter(
      event => event.type === eventTypes.RESOURCE_BREAK
    )
};

const mutationTypes = {
  SET_ROSTER: 'SET_ROSTER',
  SET_ROSTER_EVENT: 'SET_ROSTER_EVENT',
  REMOVE_ROSTER_EVENT: 'REMOVE_ROSTER_EVENT',
  SET_ROSTER_SUBSCRIPTION: 'SET_ROSTER_SUBSCRIPTION'
};
const actions = {
  async createEvent(context, event) {
    event.storeId = context.rootGetters['stores/store']._id;
    event.created = +new Date();
    event.lastModified = event.created;

    const ref = db.collection('roster').doc();
    event._id = ref.id;
    event.id = ref.id;

    await ref.set(event);

    context.commit(mutationTypes.SET_ROSTER_EVENT, event);
  },
  async updateEvent(context, event) {
    event.lastModified = +new Date();

    await db
      .collection('roster')
      .doc(event._id)
      .set(event);

    context.commit(mutationTypes.SET_ROSTER_EVENT, event);
  },
  async deleteEvent(context, event) {
    await db
      .collection('roster')
      .doc(event._id)
      .delete();

    context.commit(mutationTypes.REMOVE_ROSTER_EVENT, event);
  },
  subscribeRoster(context) {
    if (context.state.subscription) return;

    const subscription = db
      .collection('roster')
      .where('storeId', '==', context.rootGetters['stores/storeId'])
      .onSnapshot(snap => {
        const roster = docsFromSnapshot(snap);
        context.commit(mutationTypes.SET_ROSTER, roster);
      });

    context.commit(mutationTypes.SET_ROSTER_SUBSCRIPTION, subscription);
  },
  unsubscribeRoster(context) {
    const unsubscribe = context.state.subscription;

    if (unsubscribe) {
      unsubscribe();
      context.commit(mutationTypes.SET_ROSTER_SUBSCRIPTION, null);
    }
  }
};

const mutations = {
  [mutationTypes.SET_ROSTER](state, roster) {
    state.roster = roster;
  },
  [mutationTypes.SET_ROSTER_SUBSCRIPTION](state, subscription) {
    state.subscription = subscription;
  },
  [mutationTypes.SET_ROSTER_EVENT](state, event) {
    state.roster = { ...state.roster, [event._id]: event };
  },
  [mutationTypes.REMOVE_ROSTER_EVENT](state, event) {
    delete state.roster[event._id];
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
